import PSPRVContent from "../pages/PSPPage/content/PSPRVContent";
import PSPBoatContent from "../pages/PSPPage/content/PSPBoatContent";
import PSPATVContent from "../pages/PSPPage/content/PSPATVContent";
import PSPCarContent from "../pages/PSPPage/content/PSPCarContent";
import PSPClimateControlledContent from "../pages/PSPPage/content/PSPClimateControlContent";
import PSPSelfStorageContent from "../pages/PSPPage/content/PSPSelfStorageContent";
import PSPMotorcycleContent from "../pages/PSPPage/content/PSPMotorcycleContent";
import PSPElectricityContent from "../pages/PSPPage/content/PSPElectricityContent";
import PSP24HourContent from "../pages/PSPPage/content/PSP24HourContent";
import PSPDriveUpContent from "../pages/PSPPage/content/PSPDriveUpContent";
import PSPPortableContent from "../pages/PSPPage/content/PSPPortableContent";
import PSPWineContent from "../pages/PSPPage/content/PSPWineContent";
import PSPCollegeContent from "../pages/PSPPage/content/PSPCollegeContent";
import PSPBusinessContent from "../pages/PSPPage/content/PSPBusinessContent";
import PSPMilitaryContent from "../pages/PSPPage/content/PSPMilitaryContent";
import PSPBikeContent from "../pages/PSPPage/content/PSPBikeContent";
import PSPDirtBikeContent from "../pages/PSPPage/content/PSPDirtBikeContent";
import PSPGolfCartContent from "../pages/PSPPage/content/PSPGolfCartContent";
import PSPJetSkiContent from "../pages/PSPPage/content/PSPJetSkiContent";
import PSPKayakContent from "../pages/PSPPage/content/PSPKayakContent";
import PSPVehicleContent from "../pages/PSPPage/content/PSPVehicleContent";
import PSPTruckContent from "../pages/PSPPage/content/PSPTruckContent";

export const PSPContentMap = {
	// Amenity PSPs
	"24-hour-storage-units": PSP24HourContent,
	"climate-controlled-storage-units": PSPClimateControlledContent,
	"drive-up-storage-units": PSPDriveUpContent,
	"portable-storage-units": PSPPortableContent,
	"storage-units-with-electricity": PSPElectricityContent,
	"wine-storage-units": PSPWineContent,

	// Audience-Specific PSPs
	"college-storage-units": PSPCollegeContent,
	"business-storage-units": PSPBusinessContent,
	"military-storage-units": PSPMilitaryContent,

	// Vehicle Storage PSPs
	"atv-storage-units": PSPATVContent,
	"bike-storage-units": PSPBikeContent,
	"boat-storage-units": PSPBoatContent,
	"car-storage-units": PSPCarContent,
	"dirt-bike-storage-units": PSPDirtBikeContent,
	"golf-cart-storage-units": PSPGolfCartContent,
	"jet-ski-storage-units": PSPJetSkiContent,
	"kayak-storage-units": PSPKayakContent,
	"motorcycle-storage-units": PSPMotorcycleContent,
	"rv-storage-units": PSPRVContent,
	"storage-units-with-free-truck-rental": PSPTruckContent,
	"vehicle-storage-units": PSPVehicleContent,

	// Other PSPs
	"what-are-storage-units": PSPSelfStorageContent,

	rv: PSPRVContent,
	atv: PSPATVContent,
	car: PSPCarContent,
	"climate-controlled": PSPClimateControlledContent,
	motorcycle: PSPMotorcycleContent,
	electricity: PSPElectricityContent,
	"drive-up": PSPDriveUpContent,
	"storage-101": PSPSelfStorageContent,
	"24-hour": PSP24HourContent,
	portable: PSPPortableContent,
	wine: PSPWineContent,
	student: PSPCollegeContent,
	commercial: PSPBusinessContent,
	military: PSPMilitaryContent,
	bicycle: PSPBikeContent,
	boat: PSPBoatContent,
	"dirt-bike": PSPDirtBikeContent,
	"golf-cart": PSPGolfCartContent,
	"jet-ski": PSPJetSkiContent,
	kayak: PSPKayakContent,
	truck: PSPTruckContent,
	vehicle: PSPVehicleContent
};

export const PSPKeywordMap = {
	"24-hour-storage-units": "24-hour",
	"climate-controlled-storage-units": "climate-controlled",
	"drive-up-storage-units": "drive-up",
	"portable-storage-units": "portable",
	"storage-units-with-electricity": "electricity",
	"wine-storage-units": "wine",
	"college-storage-units": "student",
	"business-storage-units": "commercial",
	"military-storage-units": "military",
	"atv-storage-units": "atv",
	"bike-storage-units": "bicycle",
	"boat-storage-units": "boat",
	"car-storage-units": "car",
	"dirt-bike-storage-units": "dirt-bike",
	"golf-cart-storage-units": "golf-cart",
	"jet-ski-storage-units": "jet-ski",
	"kayak-storage-units": "kayak",
	"motorcycle-storage-units": "motorcycle",
	"rv-storage-units": "rv",
	"storage-units-with-free-truck-rental": "truck",
	"vehicle-storage-units": "vehicle",
	"what-are-storage-units": "storage-101"
};
